import React from 'react';
import { Route } from 'react-router-dom';
import { createLazyRoute } from '@core/router';

const module = () => import('./module');

export const acceptTosRoutes = <Route path="accept-tos" {...createLazyRoute(module, m => m.acceptTosRoute)} />;

export default acceptTosRoutes;
